
import SettingPoint from "components/SettingPoint";
import NotFooterLayout from "layouts/NotFooterLayout";

function SettingPointPage() {
  return (
    <>
      <NotFooterLayout namePage="ตั้งค่าการเติม Point">
        <div className="layout-content">
          <SettingPoint />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default SettingPointPage;
